
// ADD THIS FONTS IN NUXT CONFIG
export const FONT_ALLOWLIST: Record<string, { family: string; }> = {
  manrope: { family: 'Manrope' },
  inter: { family: 'Inter' },
  roboto: { family: 'Roboto' },
  caveat: { family: 'Caveat' },
}

export function fontPreloadLinks(font: string, locale: string) {
  const family = (FONT_ALLOWLIST[font] || FONT_ALLOWLIST.manrope)!.family;
  const language = locale.toLowerCase().split('-')[0];
  const subsets = ['latin'];
  if (language === 'bg' || language === 'ru') subsets.push('cyrillic');
  if (language === 'hu' || language === 'ro') subsets.push('latin-ext');

  return subsets.map(subset => ({
    key: `theme-font-${subset}`,
    rel: 'preload' as const,
    as: 'font' as const,
    type: 'font/woff2',
    crossorigin: 'anonymous' as const,
    href: `/fonts/${family}-normal-400_700-${subset}.woff2`,
  }));
}
